export const EXPORT_FILE_FORMATS = [
  { format: 'PDF', extension: '.pdf' },
  { format: 'CSV', extension: '.csv' },
  { format: 'Excel', extension: '.xlsx' },
];
